import React from 'react'

export const Sala = ({ idCenario = 0, onClick, isTransparente = false}) => {
    
    return (
        <>
            {idCenario===0 && <div className={isTransparente ? 'sala-transparente' : 'sala'} align="center" onClick={onClick}></div>}
            {idCenario===1 && <div className={isTransparente ? 'sala-transparente-cenario1' : 'sala-cenario1'} align="center" onClick={onClick}></div>}
            {idCenario===2 && <div className={isTransparente ? 'sala-transparente-cenario2' : 'sala-cenario2'} align="center" onClick={onClick}></div>}
        </>
        
    )
}

export default Sala
